import { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Dialog } from './Dialog';

/** Delphi Mesaj2(1,1,'... Eminmisiniz') karşılığı: Promise<boolean> döndüren onay penceresi */
export function confirmDialog(message: string, opts: { title?: string; ok?: string; cancel?: string; danger?: boolean } = {}): Promise<boolean> {
  return new Promise((resolve) => {
    const host = document.createElement('div');
    document.body.appendChild(host);
    const root = createRoot(host);
    function C() {
      const [open, setOpen] = useState(true);
      const close = (v: boolean) => {
        setOpen(false);
        resolve(v);
        setTimeout(() => { root.unmount(); host.remove(); }, 200);
      };
      return (
        <Dialog open={open} onOpenChange={(o) => !o && close(false)} title={opts.title ?? 'Onay'} className="w-[min(440px,92vw)]"
          footer={<>
            <button className="btn" onClick={() => close(false)}>{opts.cancel ?? 'Vazgeç'}</button>
            <button data-autofocus className={opts.danger ? 'btn btn-primary !bg-red-600 !border-red-600' : 'btn btn-primary'} onClick={() => close(true)}>{opts.ok ?? 'Tamam'}</button>
          </>}>
          <p className="whitespace-pre-wrap">{message}</p>
        </Dialog>
      );
    }
    root.render(<C />);
  });
}
